import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../../makeup/makeup_area/MakeupArea.module.sass';
import Button from '../../../../ui_kit/button/Button';
import BackButton from '../../back_button/BackButton';
import Block from '../../makeup/makeup_area/block/Block';
import HAIR_CATEGORIES from '../../../constants/hair_categories';

function HairArea(props) {
  const {
    increaseStep, decreaseStep, quiz, step,
  } = props;

  const [area, setArea] = useState(quiz.productType);
  const [customArea, setCustomArea] = useState(
    Object.values(HAIR_CATEGORIES).includes(quiz.productType) ? '' : quiz.productType,
  );

  const productType = area;

  const onNextClick = () => {
    increaseStep(
      { ...quiz, productType, concerns: productType === quiz.productType ? quiz.concerns : [] },
    );
  };

  const { color } = quiz;

  return (
    <>
      <BackButton
        decreaseStep={() => {
          decreaseStep({ ...quiz, productType });
        }}
      />
      <div className={styles['makeup-area']}>
        <div className={styles.content}>
          {step}
          <div className={styles.title}>
            What type of hair product is it?
          </div>
          <div className={styles.description}>
            Choose one.
          </div>
          <div className={styles.areas}>
            <Block
              text={HAIR_CATEGORIES.HAIR_CARE}
              active={area === HAIR_CATEGORIES.HAIR_CARE}
              onClick={() => { setArea(HAIR_CATEGORIES.HAIR_CARE); }}
              color={color}
            />
            <Block
              text={HAIR_CATEGORIES.HAIR_STYLING}
              active={area === HAIR_CATEGORIES.HAIR_STYLING}
              onClick={() => { setArea(HAIR_CATEGORIES.HAIR_STYLING); }}
              color={color}
            />
            <Block
              text={HAIR_CATEGORIES.HAIR_COLOR}
              active={area === HAIR_CATEGORIES.HAIR_COLOR}
              onClick={() => { setArea(HAIR_CATEGORIES.HAIR_COLOR); }}
              color={color}
            />
            <Block
              text={customArea}
              active={
              area ? !Object.values(HAIR_CATEGORIES).includes(area) : false
            }
              onClick={() => {
                setArea(customArea);
              }}
              color={color}
              editable
              onInputChange={(event) => {
                const inputValue = event.target.value;
                setCustomArea(inputValue);
                setArea(inputValue);
              }}
              inputPlaceholder="Other, Type Here"
            />
          </div>
          <Button
            className={`${styles.button} custom-transparent-button`}
            onClickHandler={onNextClick}
            disabled={!area}
            text="NEXT"
            color="transparent-blue"
            size="small"
          />
        </div>
      </div>
    </>
  );
}

HairArea.propTypes = {
  increaseStep: PropTypes.func.isRequired,
  decreaseStep: PropTypes.func.isRequired,
  quiz: PropTypes.shape({
    productType: PropTypes.string,
    concerns: PropTypes.arrayOf(PropTypes.string),
    color: PropTypes.string,
  }).isRequired,
  step: PropTypes.node.isRequired,
};

export default HairArea;
